import { render, staticRenderFns } from "./AgencyShipping.vue?vue&type=template&id=35ccfa98&scoped=true"
import script from "./AgencyShipping.vue?vue&type=script&lang=js"
export * from "./AgencyShipping.vue?vue&type=script&lang=js"
import style0 from "./AgencyShipping.vue?vue&type=style&index=0&id=35ccfa98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ccfa98",
  null
  
)

export default component.exports